module.exports = __webpack_public_path__ + "static/whiteknitbear-8e0160bf1cdf7647ccf93a113a4b2bfd.jpeg";